import { render, staticRenderFns } from "./MembersListWidget.vue?vue&type=template&id=bc15cfae&scoped=true"
import script from "./MembersListWidget.vue?vue&type=script&lang=js"
export * from "./MembersListWidget.vue?vue&type=script&lang=js"
import style0 from "./MembersListWidget.vue?vue&type=style&index=0&id=bc15cfae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc15cfae",
  null
  
)

export default component.exports